import {SOPutAssessmentSummary} from '../../core/assessment-summary/so-put-assessment-summary';
import {AssessmentSummaryCore} from './assessment-summary.core';
import {SOGetAssessmentSummary} from '../../core/assessment-summary/so-get-assessment-summary';
import {FormField, SelectionOption} from 'lionheartland';
import {putAssessmentSummaryFormFieldOptions} from './put-assessment-summary-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';
import {AssessmentCore} from '../assessment/assessment.core';
import {SOGetAssessment} from '../../core/assessment/so-get-assessment';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPutAssessmentSummary extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putAssessmentSummaryFormFieldOptions);

  RequestClass = SOPutAssessmentSummary

  constructor(
    public entityCore: AssessmentSummaryCore
  ) {
    super();
    if (putAssessmentSummaryFormFieldOptions.assessment) {
      putAssessmentSummaryFormFieldOptions.assessment.makeCore = true;
    }
    if (putAssessmentSummaryFormFieldOptions.project) {
      putAssessmentSummaryFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier(
        'assessment',
        SOGetAssessment,
      ),
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}